module.exports = __webpack_public_path__ + "static/media/guide-order.4d257914.jpg";